export const ERRORS_CATEGORIES = {
  VALIDATION: 'validation',
  AUTHENTICATION: 'authentication',
  BAD_REQUEST:'bad-request'
};
